import React from 'react';
import { DialogProps } from '../type';
import Modal from '../../Modal';
import Button from '../../Button';
import { WarningIcon } from '../../icons';

function WarningDialog({
  id,
  title,
  content,
  onOk,
  okLabel,
  withoutIcon,
}: DialogProps) {
  return (
    <Modal
      id={id}
      {...(withoutIcon ? {} : { icon: <WarningIcon /> })}
      type="dialog"
      isOpened={true}
      title={title}
      hasCloseFooterButton={false}
      primaryButton={
        <Button type="primary" isBlock={true} onClick={onOk}>
          {okLabel}
        </Button>
      }
    >
      {content}
    </Modal>
  );
}

WarningDialog.defaultProps = {
  okLabel: 'Ok',
};

export default WarningDialog;
